const StationSubscriptionEnum = {
  IMS: "ims",
  POS: "pos",
};

export default StationSubscriptionEnum;
